import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/card.svg'


const _hoisted_1 = { class: "form-card" }
const _hoisted_2 = { class: "form-card__inner" }
const _hoisted_3 = { class: "form-card__header" }
const _hoisted_4 = { class: "form-card__title" }
const _hoisted_5 = { class: "form-card__subtitle" }
const _hoisted_6 = { class: "form-card__input" }
const _hoisted_7 = { class: "form-card__input" }
const _hoisted_8 = { class: "form-card__confirmation" }
const _hoisted_9 = { class: "confirmation" }
const _hoisted_10 = { class: "confirmation__text" }
const _hoisted_11 = { class: "form-card__input form-card__input--last" }
const _hoisted_12 = { class: "form-card__total total total--form-card" }
const _hoisted_13 = { class: "total__item" }
const _hoisted_14 = { class: "total__text" }
const _hoisted_15 = { class: "total__number" }
const _hoisted_16 = { class: "total__item" }
const _hoisted_17 = { class: "total__text" }
const _hoisted_18 = { class: "total__number" }
const _hoisted_19 = { class: "form-card__btn" }
const _hoisted_20 = { class: "button__loader" }
const _hoisted_21 = {
  key: 0,
  class: "spinner"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "form-card__error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_input_tel = _resolveComponent("ap-input-tel")!
  const _component_ap_input_mask = _resolveComponent("ap-input-mask")!
  const _component_ap_input_checkbox = _resolveComponent("ap-input-checkbox")!
  const _component_ap_input_money = _resolveComponent("ap-input-money")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-card__icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "phone"
          })
        ], -1)),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('bank_transfer.title')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('bank_transfer.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ap_input_tel, {
          modelValue: _ctx.sender.phone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sender.phone) = $event)),
          label: _ctx.$t('from'),
          "icon-name": _ctx.icon,
          "error-text": _ctx.errors?.phone?.[0] || '',
          onKeyup: _ctx.checkOperator
        }, null, 8, ["modelValue", "label", "icon-name", "error-text", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ap_input_mask, {
          modelValue: _ctx.sender.card_number,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sender.card_number) = $event)),
          type: "cardNumber",
          label: _ctx.$t('bank_transfer.to'),
          placeholder: _ctx.$t('bank_transfer.card_placeholder'),
          "error-text": _ctx.errors?.card_number?.[0] || '',
          full: "",
          onKeyup: _ctx.onKeyup
        }, null, 8, ["modelValue", "label", "placeholder", "error-text", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ap_input_checkbox, {
            checked: _ctx.sender.confirmation,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sender.confirmation) = $event)),
            class: "confirmation__input",
            onKeyup: _ctx.onKeyup
          }, null, 8, ["checked", "onKeyup"]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('bank_transfer.confirm')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ap_input_money, {
          modelValue: _ctx.sender.amount,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sender.amount) = $event)),
          "error-text": _ctx.errors?.amount?.[0] || '',
          label: _ctx.$t('bank_transfer.sum_label'),
          currency: "",
          hint: _ctx.hintText,
          onKeyup: _ctx.onKeyup
        }, null, 8, ["modelValue", "error-text", "label", "hint", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.remittancesToCard?.commission?.text  || _ctx.$t('bank_transfer.hint')), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.remittancesToCard?.commission?.amount  || 0) + " ₸ ", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('write_off_amount')), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.remittancesToCard?.commission?.total || 0) + " ₸ ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_ap_button, {
          type: "primary",
          full: "",
          disable: _ctx.btnIsDisable,
          onClick: _ctx.pay
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.checking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('continue')), 1))
            ])
          ]),
          _: 1
        }, 8, ["disable", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.errors?.message), 1)
    ])
  ]))
}